import { render, staticRenderFns } from "./add-task.vue?vue&type=template&id=629cfdc0&"
import script from "./add-task.ts?vue&type=script&lang=ts&"
export * from "./add-task.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports